import { useCompanyBranchInfo } from "@/api/services/main/company";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { CompanyBranchForm } from "@/features/company/components/CompanyBranchForm";
import { convertCompanyBranchResToFormDataDto } from "@/features/company/utils/convertResToFormData";
import { FC } from "react";

type TCompanyBranchEditPageProps = {};

export const CompanyBranchEditPage: FC<TCompanyBranchEditPageProps> = () => {
  const { data, isLoading } = useCompanyBranchInfo();

  if (isLoading) return <LoadingPage />;

  return <CompanyBranchForm isHeadQuarter={data?.data.isHeadquarters} previousValues={convertCompanyBranchResToFormDataDto(data?.data)} />;
};
